import { call, put, select } from 'redux-saga/effects';
import { setDomainUsersUsageHistory } from '../../../../state/analytic/analyticAdminSlice';
import { selectUserCredentials } from '../../../../state/userCredential/userCredentialSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* fetchDomainUsersUsageHistorySaga() {
    const { domain } = yield select(selectUserCredentials);
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            `usage/domains/${encodeURIComponent(domain)}/users/history`
        );
        yield put(setDomainUsersUsageHistory(data));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to fetch domain users usage history', err?.response?.status, err?.message);
    }
}